import { LocalStorageService } from './localStorage.service';

const AuthStorageKeysMap = {
  ACCESS_TOKEN: 'access_token',
  ROLES: 'roles',
  USER: 'user',
  RESULT_ID: 'result_id'
};

export const AuthService = class {
  static setLogin(loginData) {
    LocalStorageService.set(
      AuthStorageKeysMap.ACCESS_TOKEN,
      loginData.access_token
    );
    LocalStorageService.set(
      AuthStorageKeysMap.ROLES,
      loginData.user.short_roles
    );
    LocalStorageService.set(AuthStorageKeysMap.USER, loginData.user);

    return loginData;
  }

  static logOut() {
    LocalStorageService.remove(AuthStorageKeysMap.ACCESS_TOKEN);
    LocalStorageService.remove(AuthStorageKeysMap.ROLES);
    LocalStorageService.remove(AuthStorageKeysMap.USER);
  }

  static getToken() {
    return LocalStorageService.get(AuthStorageKeysMap.ACCESS_TOKEN);
  }

  static getResultId() {
    return LocalStorageService.get(AuthStorageKeysMap.RESULT_ID);
  }

  static checkLogin() {
    let token = AuthService.getToken();

    return Boolean(token);
  }

  static getUser() {
    return LocalStorageService.getJSON(AuthStorageKeysMap.USER);
  }
};
